'use client';

import { CustomLink } from '@/components/atoms/CustomLink/CustomLink';
import { IAnimation, ICommonProps } from '@/types/global';
import { Typography } from '@/components/atoms/Typography/Typography';
import * as Styled from './ProjectsCounter.styled';
import { IFilter } from '@/components/organisms/FilteredProjectsGallery/FilteredProjectsGallery.types';

export interface ICounter {
  href: string;
  text: string;
  filter: IFilter;
  count: number;
}

export interface IProjectsCounterProps extends ICommonProps {
  counters: ICounter[];
  animationContainer?: IAnimation;
}

export const ProjectsCounter = ({ counters }: IProjectsCounterProps) => {
  return (
    <Styled.ProjectsCounterContainer>
      {counters.map((counter, index) => (
        <CustomLink key={index} href={`/${counter.href}`}>
          <Typography as="span" text={counter.filter.text} />
          {counter.count > 0 && (
            <Typography
              as="span"
              text={`&nbsp;<span style="color: var(--c-font-secondary); font-weight: 200;"> / ${counter.count.toString()}</span>`}
            />
          )}
        </CustomLink>
      ))}
    </Styled.ProjectsCounterContainer>
  );
};
